import React, { FC } from 'react';
import { IFileThumbnail } from '../../../../../common/Thumbnails/types';

export const Empty: FC<IFileThumbnail> = () => <div />;
